import { Controller } from '@hotwired/stimulus'

const COOKIE_NAME = 'tz'
const RELOAD_GUARD_KEY = 'tzReloadedFor'

// Detects the visitor's IANA time zone and stores it in a cookie so the
// server can render timestamps (review dates, order history, etc.) in
// local time instead of UTC. Reloads once after first setting the cookie
// so the very first page view is already correct; the reload guard
// prevents a loop if cookies are blocked.
export default class extends Controller {
  connect() {
    const zone = Intl.DateTimeFormat().resolvedOptions().timeZone
    if (!zone || zone === this.#currentCookie()) return

    document.cookie = `${COOKIE_NAME}=${zone}; path=/; max-age=31536000; SameSite=Lax`

    if (window.sessionStorage.getItem(RELOAD_GUARD_KEY) === zone) return
    window.sessionStorage.setItem(RELOAD_GUARD_KEY, zone)
    window.location.reload()
  }

  #currentCookie() {
    return document.cookie
      .split('; ')
      .find(row => row.startsWith(`${COOKIE_NAME}=`))
      ?.split('=')[1]
  }
}
